module.exports = __webpack_public_path__ + "img/0ab380022f4b63bb2ef0d05eef4da037.png";